import { Paper } from '@mui/material';
import { CertificationCompletionEntry } from 'types/admin/analytics';
import { CardHeader } from '../CardHeader/CardHeader';
import { CertificationTrendsChart } from '../CertificationTrendsChart/CertificationTrendsChart';

export const CertificationTrendsChartCard = ({
  trends,
  chartColors,
}: {
  trends: [string, CertificationCompletionEntry][];
  chartColors: string[];
}) => {
  return (
    <Paper className='analytics-card'>
      <CardHeader title='Certification trends' badges={['DB']} />
      <CertificationTrendsChart trends={trends} chartColors={chartColors} />
    </Paper>
  );
};
